/**
 * UI language list: BCP-47 `lng` for i18next + display meta for switcher.
 *
 * - `code`: 语言/地区缩写，仅用于显示。
 * - `flagCode`: 可选；当 `code` 不是 ISO 3166-1 alpha-2 国家码时，提供用于 flag icon 的国家码。
 *   未提供时回退到 `code`。
 */
export type UiLanguage = {
  readonly lng: string;
  readonly code: string;
  readonly flagCode?: string;
  readonly name: string;
  readonly sub: string;
};

export const UI_LANGUAGES: ReadonlyArray<UiLanguage> = [
  { lng: "en", code: "EN", flagCode: "US", name: "English", sub: "English" },
  { lng: "zh-CN", code: "CN", name: "简体中文", sub: "Simplified Chinese" },
  { lng: "vi", code: "VN", name: "Tiếng Việt", sub: "Vietnamese" },
  { lng: "th", code: "TH", name: "ภาษาไทย", sub: "Thai" },
  { lng: "id", code: "ID", name: "Bahasa", sub: "Indonesian" },
  { lng: "ko", code: "KR", name: "한국어", sub: "Korean" },
  { lng: "ja", code: "JP", name: "日本語", sub: "Japanese" },
  { lng: "es", code: "ES", name: "Español", sub: "Spanish" },
  { lng: "pt", code: "PT", name: "Português", sub: "Portuguese" },
  { lng: "ru", code: "RU", name: "Русский", sub: "Russian" },
];

export const SUPPORTED_LANGUAGES: string[] = UI_LANGUAGES.map((l) => l.lng);
